
export default function ReviewsPage() {
  return (
    <div>ReviewsPage</div>
  )
}
